var SUPERSTRONG = (!SUPERSTRONG ? {} : SUPERSTRONG);
SUPERSTRONG.events = {};
SUPERSTRONG.events.breakpointChange = 'be.superstrong.breakpointChange';
